module.exports = __webpack_public_path__ + "media/images/flag/bd-49d97b751a0fce7e42d5139c052fdbbc.jpg";